import { DateFormat } from '@youhelp/common/const/date';

export const DATE_PICKER_VALUE_DATE_FORMAT_DEFAULT = 'yyyy.MM.dd';
export const TIME_PICKER_VALUE_DATE_FORMAT_DEFAULT = 'HH:mm';
export const DATE_TIME_PICKER_VALUE_DATE_FORMAT_DEFAULT = DateFormat.DateTimePostgreSQL;

export const CALENDAR_WIDTH = 320;

export const POPPER_OFFSET = 8;
export const POPPER_PADDING = 8;

export const POPPER_MODIFIERS = [
  {
    name: 'offset',
    options: {
      offset: [0, POPPER_OFFSET],
    },
  },
  {
    name: 'preventOverflow',
    options: {
      boundary: 'clippingParents',
      padding: POPPER_PADDING,
    },
  },
  {
    name: 'flip',
    options: {
      fallbackPlacements: ['bottom-start', 'bottom-end', 'top-start', 'top-end'],
    },
  },
];